import React from 'react';
import { motion } from 'framer-motion';
import { X, Check, Award } from 'lucide-react';
const notThis = ['This is not a random collection of massage PDFs.', 'This is not an anatomy textbook you have to translate into real-world practice yourself.', 'This is not a list of disconnected techniques with no explanation of how to structure them.'];
export function SolutionReveal() {
  return <section className="py-20 px-4 bg-sand border-y border-warmgray" data-id="element-235" data-mp="z0uxd23kwi1q">
      <div className="max-w-4xl mx-auto text-center" data-id="element-236" data-mp="u29tmsp4bg8j">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} data-id="element-237" data-mp="u3l6di0jjybs">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-full bg-terracotta/10 text-terracotta mb-5" data-id="element-238" data-mp="2ffmo7al2th8x">
            <Award size={26} aria-hidden="true" data-id="element-239" data-mp="2bwieva1lyodj" />
          </div>
          <p className="text-terracotta font-semibold tracking-[0.18em] uppercase text-xs mb-3" data-id="element-240" data-mp="2gus659k7p4tv">
            The Complete Professional System
          </p>
          <h2 className="text-2xl md:text-4xl font-serif font-bold mb-4 text-charcoal" data-id="element-241" data-mp="2kwwze76qzzfz">
            Massage Therapist Ready
          </h2>
          <p className="text-base md:text-lg text-charcoal-soft mb-10" data-id="element-242" data-mp="1t57nysvvubln">
            7 Complete Volumes · 150 Ready-to-Use Massage Sessions · 5 Exclusive
            Bonuses · Everything Organized for Professional Use
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-6 text-left" data-id="element-243" data-mp="225476ezi6i9b">
          <motion.div initial={{
          opacity: 0,
          x: -16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="space-y-3 bg-paper p-6 rounded-2xl border border-warmgray" data-id="element-244" data-mp="26wcijgke8dp4">
            {notThis.map(item => <div key={item} className="flex items-start gap-3" data-id="element-245" data-mp="2qk2b55q16o0z">
                <X className="text-terracotta-dark shrink-0 mt-1" size={18} aria-hidden="true" data-id="element-246" data-mp="2qldgvb31e5uq" />
                <p className="text-charcoal-muted text-sm" data-id="element-247" data-mp="1yswkdfw7a2od">{item}</p>
              </div>)}
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 16
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="bg-terracotta/10 p-6 rounded-2xl border border-terracotta/30" data-id="element-248" data-mp="1tvcx5qhiyfka">
            <div className="flex items-start gap-3" data-id="element-249" data-mp="3mpchv4pqkbbo">
              <Check className="text-terracotta-deep shrink-0 mt-1" size={20} aria-hidden="true" data-id="element-250" data-mp="3qrh7ztgz6ptk" />
              <p className="text-charcoal font-medium text-base leading-relaxed" data-id="element-251" data-mp="3ctsnimqtlkp1">
                This is a complete professional massage therapy system designed
                to help you walk into every appointment more prepared,
                organized, and confident.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}